// extracted by mini-css-extract-plugin
export const article_item = "ArticleItem-module--article_item--20JcN";
export const article_item__thumbnail = "ArticleItem-module--article_item__thumbnail--dNJIq";
export const article_item__container = "ArticleItem-module--article_item__container--JWGxP";
export const article_item__title = "ArticleItem-module--article_item__title--LWIRY";
export const article_item__date = "ArticleItem-module--article_item__date--OQnXL";
export const article_item__excerpt = "ArticleItem-module--article_item__excerpt--1JIWx";
export const article_item__view_more = "ArticleItem-module--article_item__view_more--1yLNy";